import { render, staticRenderFns } from "./contract_receive.vue?vue&type=template&id=148d366a"
import script from "./contract_receive.vue?vue&type=script&lang=js"
export * from "./contract_receive.vue?vue&type=script&lang=js"
import style0 from "./contract_receive.vue?vue&type=style&index=0&id=148d366a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports